import SlideUpDown from 'vue-slide-up-down';
Vue.component('slide-up-down', SlideUpDown);